<template>
    <modal title="Error List" @close="$emit('close')">
        <template #content>
            <loadArea v-if="data==null"></loadArea>
            <ul class="errorlist" v-if="data!=null">
                <li><p class="col-12 notFound" v-if="data.length==0">Not Found Errors</p></li>
                <li v-for="item in data" :key="item.Id" class="row">
                    <strong class="col-3">{{$moment(item.Date).format("DD.MM.YYYY hh:mm:ss")}}</strong>
                    <p class="col-8" @click="detail=item"><span>{{item.Message}}</span></p>
                </li>
            </ul>
        </template>
        <template v-if="data!=null && data.length>0" #foot>
            <Btn class="btn-danger btn-sm" @click="clean" :process="process">Error List Clean</Btn>
        </template>
    </modal>
    <modal :title="'Error Detay '+$moment(detail.Date).format('DD.MM.YYYY hh:mm:ss')" size="xl" @close="detail=null" v-if="detail!=null">
        <template #content>
            <pre>{{detail.Message}}</pre>
        </template>
    </modal>
</template>

<script>
    export default {
        name:"errorList",
        props:{
            CustomerProviderId:Number
        },
        data(){
            return{
                data:null,
                detail:null,
                process:false
            }
        },
        created(){
            this.$appAxiosAdmin.get(`/Kolayrez/ScanErrors/`+this.CustomerProviderId).then(response => {
                this.data=response.data;
            }).catch(err=>{
                this.$isError(err);
            });
        },
        methods:{
            clean(){
                this.process=true;
                this.$appAxiosAdmin.delete(`/Kolayrez/ScanErrors/`+this.CustomerProviderId).then(() => {
                    this.data=[];
                    this.process=false;
                }).catch(err=>{
                    this.process=false;
                    this.$isError(err);
                });
            }
        }
    }
</script>

<style>
    .errorlist li{
        border-top:1px solid #ddd;
        font-size:12px;
        font-weight:500;
        line-height:18px;
        margin:0 !important;
        cursor:pointer;
    }
    .errorlist li:first-child{
        border-top:none;
    }
    .errorlist li strong{
        font-weight: 500;
        padding: 2px 5px;
    }
    .errorlist li p{
        padding: 2px 5px;
    }
    .errorlist li p.notFound{
        text-align:center;
        padding:30px 5px;
    }
    .errorlist li p span{
        display:block;
        white-space:nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .errorlist li:nth-child(even){
        background:#f9f9f9;
    }
    .errorlist li:hover{
        background:#fff38e;
    }
</style>